import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { EntryPointRouteParams } from '@atlassian/jira-entry-points-plugin/src/common/types.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import OnboardingWizardInnerPermissionsQuery from './__generated__/OnboardingWizardInnerPermissionsQuery.graphql';

export const onboardingHubWizardWithDelegatedAdminEntryPoint = createEntryPoint({
	// Using `JSResourceForInteraction` to avoid SSR
	root: JSResourceForInteraction(() =>
		import(
			/* webpackChunkName: "async-onboarding-hub-wizard-with-delegated-admin" */ './OnboardingWizardInner.tsx'
		).then((module) => module.OnboardingWizardWithDelegatedAdmin),
	),
	getPreloadProps: ({
		context,
		tenantContext: { cloudId, isAdmin, appEditions },
	}: EntryPointRouteParams) => ({
		extraProps: {
			id: context.match.params?.id || '',
		},
		queries: {
			permissionsQuery: {
				options: { fetchPolicy: 'store-and-network' as const },
				parameters: OnboardingWizardInnerPermissionsQuery,
				variables: {
					cloudId,
					// We can skip the permission check when:
					// 1. The user is an admin (because admins can automatically manage custom onboarding configs), or
					// 2. Upsell is enabled (because upsell is only available to admins)
					skipDelegatedAdminCheck:
						isAdmin ||
						(appEditions?.software !== 'PREMIUM_EDITION' &&
							fg('restrict-custom-onboarding-to-premium-tier')),
				},
			},
		},
	}),
});
